import { axiosApi, staticFilesBaseUrl } from 'app/api/api';
import each from 'lodash-es/each';
import { FileData } from 'entities/file/model/fileModel';
import { FolderData } from 'entities/folder/model/folderModel';
import {
  CreateSectionParams,
  SectionData,
  SectionLink,
  SectionLinkIcon,
  UpdateSectionParams,
} from 'entities/section/model/sectionModel';
import { TableData } from 'entities/table/model/tableModel';
import { SortContentKey, SortContentOrder } from 'entities/types';

const processSectionImage = (section: SectionData, hash = '') => {
  if (section.image_src) {
    section.image_src = staticFilesBaseUrl + section.image_src + hash;
  }
};

export const sectionsApi = {
  fetch: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<SectionData>(`/section/${id}`, {
      params: { in_trash },
    });

    processSectionImage(res.data);

    return res.data;
  },
  fetchBulk: async () => {
    const res = await axiosApi.get<{ sections: SectionData[] }>(
      '/section/bulk'
    );

    each(res.data.sections, (section) => {
      processSectionImage(section);
    });

    return res.data.sections;
  },
  create: async (params: CreateSectionParams) => {
    const fd = new FormData();
    if (params.image_src) {
      fd.append('image_src', params.image_src);
    }

    const res = await axiosApi.post<SectionData>('/section', fd, {
      params: {
        name: params.name,
      },
    });

    processSectionImage(res.data);

    return res.data;
  },
  update: async (id: string, params: UpdateSectionParams) => {
    const fd = new FormData();
    fd.append('image_src', params.image_src || '');

    const res = await axiosApi.put<SectionData>(`/section/${id}`, fd, {
      params: {
        name: params.name,
      },
    });

    // Форсим обновление картинки через hash
    processSectionImage(res.data, `?hash=${String(Math.random())}`);

    return res.data;
  },

  delete: async (id: string) => {
    await axiosApi.delete<void>(`/section/${id}`);

    return id;
  },

  getContent: async (
    id: string,
    params: {
      in_trash: string | null;
      sort_by: SortContentKey;
      sort_direction: SortContentOrder;
    }
  ) => {
    const res = await axiosApi.get<{ content: any[] }>(
      `/section/${id}/content`,
      { params }
    );

    return res.data.content;
  },

  fetchFolders: async (
    id: string,
    { in_trash }: { in_trash: string | null }
  ) => {
    const res = await axiosApi.get<{ folders: FolderData[] }>(
      `/section/get_folders/${id}`,
      { params: { in_trash } }
    );

    return res.data.folders;
  },

  fetchFiles: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<{ files: FileData[] }>(
      `/section/non_folder_files/${id}`,
      { params: { in_trash } }
    );

    return res.data.files;
  },

  fetchTables: async (
    id: string,
    { in_trash }: { in_trash: string | null }
  ) => {
    const res = await axiosApi.get<{ tables: TableData[] }>(
      `/section/non_folder_tables/${id}`,
      { params: { in_trash } }
    );

    return res.data.tables;
  },
};
